import { createFileRoute } from '@tanstack/react-router';

import { CostOverviewPage } from '@/features/cost/overview-page';

export const Route = createFileRoute('/_app/projects/$projectId/cost/overview')({
  component: CostOverviewRoute,
});

function CostOverviewRoute() {
  const { projectId } = Route.useParams();
  return <CostOverviewPage projectId={projectId} />;
}
